import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Loadable } from '@wix/wix-vod-shared/components';
import ReloadChannelPaymentDataOnPayment from '../../data-components/reload-channel-payment-data-on-payment';
import { getPaymentInfo } from '../../redux/actions/channel/payment';

const mapStateToProps = null;

const mapDispatchToProps = {
  getPaymentInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class WithPaymentInfoLayout extends React.Component {
    static propTypes = {
      children: PropTypes.element.isRequired,
      getPaymentInfo: PropTypes.func.isRequired,
      match: PropTypes.object.isRequired,
    };

    loadData = () =>
      this.props.getPaymentInfo(this.props.match.params.channelId);

    render() {
      const { children } = this.props;

      return (
        <Loadable loader={this.loadData}>
          <div>
            {children}
            <ReloadChannelPaymentDataOnPayment />
          </div>
        </Loadable>
      );
    }
  },
);
